import { snakeCase as _snakeCase } from 'lodash-es'

export function adaptObjectToSearchParams(params: { [key: string]: any }, option?: { filter?: (value: any) => boolean }) {
  const qs = new URLSearchParams()
  Object.entries(params)
    .filter(([_, value]) => (option?.filter ? option.filter(value) : !!value))
    .forEach(([key, value]) => {
      qs.append(_snakeCase(key), `${value}`)
    })
  return qs
}

export function addEndpointPrefix(isAddPrefix: boolean) {
  return isAddPrefix ? '/pub' : ''
}
